var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00007 1.2C4.01184 1.2 2.40007 2.81177 2.40007 4.8V6.95147L1.9758 7.37573C1.8042 7.54733 1.75287 7.8054 1.84574 8.02961C1.93861 8.25381 2.15739 8.4 2.40007 8.4H9.60007C9.84274 8.4 10.0615 8.25381 10.1544 8.02961C10.2473 7.8054 10.1959 7.54733 10.0243 7.37573L9.60007 6.95147V4.8C9.60007 2.81177 7.98829 1.2 6.00007 1.2Z",
    fill: "#B9A2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00005 10.8C5.00594 10.8 4.20005 9.99411 4.20005 9H7.80005C7.80005 9.99411 6.99416 10.8 6.00005 10.8Z",
    fill: "#B9A2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ca70687c3d21125cd7264f07a09859e3.svg";
export { ForwardRef as ReactComponent };